import React from 'react';
import "./Value.css";

const Value = () => {
  return (
    <div className='Value'>
        <h3>Why Ubeka</h3>
        <div className="value-c">
          <div className="value-cont">
            <h4>African Skin</h4>
            <p>Ubeka is being trained on African skin tones, hence providing more accurate skinacre recommendations perfect for your melanin-rich skin</p>
        </div>
        <div className="value-cont">
            <h4>AI Skin Scan</h4>
            <p>With just your smartphone camera, Ubeka provides a detailed skin analysis to help you understand your skin's unique needs</p>
        </div>
        <div className="value-cont">
            <h4>Personalized Routine</h4>
            <p>Get a skincare routine tailored specifically for your skin, glow in your own way. Monitor how your skin improves overtime</p>
        </div>
        <div className="value-cont">
            <h4>Smart Product Marketplace</h4>
            <p>Buy Dermatology recommended products directly from Ubeka in-app marketplace and have it delivered directly to you</p>
        </div>
        </div>
    </div>
  )
}

export default Value